jQuery($ => {
  class FilterCheckboxDropdown {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._triggers = this._element.find('.m-filter-checkbox-dropdown__button');
      this._loadMore = this._element.find('.m-filter-checkbox-dropdown__load-more');
      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._triggers.each((_, el) => {
        $(el).on('click', () => this.handleDropdowns(el));
      });

      this._loadMore.on('click', this.handleLoadMore);
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Dropdowns
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleDropdowns = (el) => {
      this._trigger = $(el);
      this._parent = this._trigger.closest('.m-filter-checkbox-dropdown');
      this._dropdown = this._trigger.siblings('.m-filter-checkbox-dropdown__wrapper');

      if (this._parent.hasClass('m-filter-checkbox-dropdown--open')) {
        this._dropdown.slideUp();
        this._parent.removeClass('m-filter-checkbox-dropdown--open');
      } else {
        this._dropdown.slideDown()
        this._parent.addClass('m-filter-checkbox-dropdown--open');
      }

    }

    handleLoadMore = () => {
      this._loadMore = $(this._loadMore);
      this._list = this._loadMore.closest('.m-filter-checkbox-dropdown__wrapper').find('.m-filter-checkbox-dropdown__list');

      if (this._list.hasClass('m-filter-checkbox-dropdown__list--hide-items')) {
        this._list.removeClass('m-filter-checkbox-dropdown__list--hide-items');
        this._loadMore.text('Show Less');
      } else {
        this._list.addClass('m-filter-checkbox-dropdown__list--hide-items');
        this._loadMore.text('Load More');
      }

    }
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.filter_checkbox_dropdown = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].filter_checkbox_dropdown = new FilterCheckboxDropdown(_[i], opt);
      else
        ret = _[i].filter_checkbox_dropdown[opt].apply(_[i].filter_checkbox_dropdown, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-filter-checkbox-dropdown').filter_checkbox_dropdown();
});